export const buildPath = (
  basePath: string,
  params: { [key: string]: string | number | boolean | undefined | null },
): string => {
  const query = Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');

  return query ? `${basePath}?${query}` : basePath;
};

export const replaceEmptyStringWithNull = (data: Record<string, any> | any[]) => {
  // Check for non-object, non-array values
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  // Handle non-plain objects (like Date) and arrays
  if (data.constructor !== Object) {
    // If it's an array, process its object elements
    if (Array.isArray(data)) {
      return data.map((element) =>
        typeof element === 'object' && element !== null ? replaceEmptyStringWithNull(element) : element,
      );
    }
    // Return non-plain objects as is
    return data;
  }

  if (typeof data === 'object' && data !== null) {
    // Process object properties
    const normalisedData: Record<string, any> = {};

    for (const key in data) {
      const value = data[key];

      normalisedData[key] =
        typeof value === 'string' && value.trim() === ''
          ? null // Replace empty strings with null
          : typeof value === 'object'
            ? replaceEmptyStringWithNull(value) // Recursively process nested objects
            : value; // Preserve other types
    }

    return normalisedData;
  }

  // Preserve non-object values
  return data;
};
